export function usdTextToCents(text: string): number {
  const [whole = '0', fraction = ''] = text.split('.');
  const padded = `${fraction}000`.slice(0, 3);
  const cents = Number(whole) * 100 + Number(padded.slice(0, 2));
  return Number(padded[2]) >= 5 ? cents + 1 : cents;
}
